module.exports = __webpack_public_path__ + "img/icon_comment.faf0c398.svg";